export const text =
  '【TiDB 社区第三届专栏征文大赛】超丰富周边奖励、返场行李箱、BOSE 耳机、SKG颈椎按摩仪、新款冲锋衣等你来拿！';
export const link = 'https://asktug.com/t/topic/1022105';
